export type MobileNavLayout = {
  rowCount: number;
  totalHeight: number;
  openDefaultY: number;
  hiddenY: number;
  bufferCount: number;
};

export function getMobileNavLayout(
  itemCount: number,
  columnCount = 3,
  rowHeight = 70,
): MobileNavLayout {
  if (!Number.isInteger(itemCount) || itemCount <= 0) {
    throw new Error('itemCount must be a positive integer');
  }
  if (!Number.isInteger(columnCount) || columnCount <= 0) {
    throw new Error('columnCount must be a positive integer');
  }
  if (!Number.isFinite(rowHeight) || rowHeight <= 0) {
    throw new Error('rowHeight must be a positive number');
  }

  const rowCount = Math.ceil(itemCount / columnCount);
  const totalHeight = rowCount * rowHeight;

  return {
    rowCount,
    totalHeight,
    openDefaultY: totalHeight - rowHeight,
    hiddenY: totalHeight,
    bufferCount: (columnCount - (itemCount % columnCount)) % columnCount,
  };
}
